export default {
  slug: null,
  currentCompanyId: -1,
  referrer: '',
  departments: [],
  departmentsLoaded: false,
  locations: [],
  locationsLoaded: false,
  filters: ['locations', 'career-levels', 'departments'],
  jobalertFilters: ['locations', 'career-levels', 'departments'],
  benefits: [],
  imprint: [],
  jobportalOnly: true,
  showExternalAdvert: false,
  isInternal: false,
  internalToken: '',
  jobDataFields: [],
  pageTitle: [],
  pageDescription: [],
  languages: {},
  jobsDefaultTopContent: [],
  jobsDefaultBottomContent: [],
  footerContent: null,
  showAvailableFiltersOnly: true,
  acceptTalentpoolInApplicationProcess: false,
  candidateAccountMode: 0,
  forceNoIndex: false,
  customDataPrivacyUrl: null,
  customImprintUrl: null,
  defaultClaim: null,
  homeSearchField: false,
  homeJobsButton: false,
  jobsContentPosition: 'bottom',
  jobsDefaultContentPosition: 'bottom',
  heroVideoUrl: '',
  baseUrl: '',
  jobportalBaseUrl: '',
  jobsLayout: 'list',
  jobsLayoutToggle: false,
  hasCustomSocialMediaIcons: false,
  hasLinkToJobportal: true,
  customLinkToJobportal: '',
  customChildCompanyLogos: {},
  customChildCompanyLogoAltText: {},
  customChildCompanyLogoUrl: {},
  additionalFooterLinks: {},
  customScripts: '',
  companyApiUrls: {},
  usePreviousJobsListForm: false,
  disableQuestionsForInternalApplications: false,
  recommendedChannel: false,
  recommendedChannelMessage: [],
  useMatomo: false,
  matomoUrl: '',
  matomoSiteId: '',
  useGoogleAnalytics: false,
  googleAnalyticsIdentifier: '',
  googleAnalyticsId: '',
  customCookieBanner: false,
  customAnalyticsScript: '',
  customAnalyticsAcceptScript: '',
  customAnalyticsRejectScript: '',
  showBlacklistedJoboffers: false,
  benefitsColor: ''
};
